import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import TripCardHelp from '../../TripCardHelp';
import { Message } from '../styles';
import { XCircleIcon } from './styles';

const Reproved = () => {
  const { t } = useStoreTranslation();

  return (
    <TripCardHelp icon={<XCircleIcon />} withContactButtons title={t('customerSupport.denied.title')}>
      <Message>{t('customerSupport.denied.message')}</Message>
    </TripCardHelp>
  );
};

export default Reproved;
